import { paramsEncode } from './index';
import {message} from 'antd';

/**
 *
 * @param {Strong} url 请求的地址，如果是get请求，会把参数拼在这后面
 * @param {String} method 请求的方式，
 * @param {Object} body 如果是post请求，参数采用object形式传入
 * @return {Promise} 返回一个promise对象。
 * 对于错误的处理，会将返回结果序列化以后抛出去，
 */
export default async function request(url, method = 'GET', body = {}) {
    // debugger;
    let token = localStorage.getItem('HippoUserInfo') ? JSON.parse(localStorage.getItem('HippoUserInfo')).token : null;
    let reqConfig = {
        method,
        headers: { 'Content-type': 'application/json', Token: token },
    };
    if (method.toLocaleLowerCase() === 'post' || method.toLocaleLowerCase() === 'delete') {
        if (url.indexOf('//120.92.118.247/upload') > -1) {
            reqConfig.headers = {'Content-Type': 'multipart/form-data'};
            reqConfig.body = body;
        } else {
            reqConfig.body = JSON.stringify(body);
        }
    }
    if (url.indexOf('120.92.118.247') > -1) {
        reqConfig.headers.Authorization = 'Basic aGlwcG86aGlwcG8=';
    }
    // try {
    let response = await fetch(url, reqConfig);
    let result = await response.json();
    if (url.indexOf('getDspUrl') > -1) {
        // 获取apiUrl接口需要特殊处理
        let apiUrl = '';
        if (result.success) {
            apiUrl = result.data.api;
        }
        return apiUrl;
    } else if (url.indexOf('//120.92.118.247/fileList.php') > -1) {
        switch (result.code) {
            case 200:
                return {list: result.data, total: result.count};
            case 10101:
                alert('用户身份过期，请重新登录');
                window.location.href = '/login';
                return;
            default:
                message.error(result.desc);
                console.log(result);
                throw new Error(JSON.stringify(result.msg));
        }
    } else {
        switch (result.code) {
            case 200:
                return result.data;
            case 10101:
                alert('用户身份过期，请重新登录');
                window.location.href = '/login';
                return;
            default:
                message.error(result.desc);
                console.log(url);
                console.log(result);
                throw new Error(JSON.stringify(result.desc));
        }
    }
    // } catch (e) {
    //     console.log('===========e.message==========');
    //     console.log(e.message);
    //     throw e;
    // }
}



// WEBPACK FOOTER //
// ./utils/request.js